import React from 'react';
import { DocumentUploader } from '@vortx/shared-ui';

export function EVDataUploader({ onExtractionComplete, projectId, ...props }) {
    return (
        <DocumentUploader
            defaultDocumentType="fleet_operations"
            allowedDocumentTypes={['fleet_operations', 'ev_charging_data', 'meter_data', 'load_profile']}
            title="Upload Fleet Data"
            description="Upload fleet operational data for AI extraction of vehicle schedules"
            acceptedFileTypes=".csv,.pdf,.xlsx"
            projectId={projectId}
            onExtractionComplete={onExtractionComplete}
            {...props}
        />
    );
}
